import Vue from 'vue'
import Router from 'vue-router'
import main from '@/view/main'
import Home from '@/view/index'
import schoolList from '../view/school/schoolList.vue'
import schoolDetail from '../view/school/schoolDetail'
import rank from '../view/school/rank.vue'
import specialtyList from '../view/specialty/specialtyList.vue'
// import scoretable from '../view/info/yifenyiduan.vue'
import openSchool from '../view/specialty/openSchool.vue'
import specialtyDetail from '../view/specialty/specialtyDetail.vue'
import provinceLine from '../view/info/provinceLine.vue'
import futureEasy from '../view/futureEasy.vue'
import personalCenter from '../view/me/personalCenter.vue'
import focusSchool from '../view/me/focusSchool.vue'
import feedback from '../view/me/feedback.vue'
import yuyue from '../view/me/yuyue.vue'
import yifenyiduan from '../view/info/yifenyiduan'
import focusProfessional from '../view/me/focusProfessional.vue'
import artificial from '../view/volunteer/artificial'
import Guide from '../view/school/Guide'
import xinxi from '../view/info/xinxi'
import xinxiDetail from '../view/info/xinxiDetail'
import form from '../view/volunteer/form'
import ai from '../view/volunteer/ai'
import aiChange from '../view/volunteer/aiChange'
import myvol from '../view/me/myvol'
import volSchoolList from '../view/volunteer/volSchoolList'
import mbti from '../view/test/mbti'
import testResult from '../view/test/testResult'
import huolande from '../view/test/huolande'
import huolandeResult from '../view/test/huolandeResult'
import artificialList from '../view/volunteer/artificialList'
import growthRecord from '../view/me/growthRecord/growthRecord'
import addRecord from '../view/me/growthRecord/addRecord'
import aiList from '../view/volunteer/aiList'
import zhiyeList from '../view/info/zhiyeList'
import zhiyeDetail from '../view/info/zhiyeDetail'
import term from '../view/info/term'
import chooseSubjects from '../view/new/chooseSubjects'
import growthDetail from '../view/me/growthRecord/growthDetail'
import jump from '@/view/jump'
import independent from '../view/volunteer/independent'
import switchLogin from '../view/me/switchLogin'
import myWater from '../view/me/myWater'
import myBill from '../view/me/myBill'
import teacherIntentionList from '../view/me/teacherIntentionList'
import customDetail from '../view/me/customDetail'
import promote from '../view/info/promote'
Vue.use(Router)
export default new Router({
  routes: [{
    path: '/',
    name: 'main',
    component: main,
    redirect: '/Home',
    children: [{
        path: '/Home',
        name: 'Home',
        component: Home
      }, {
        path: '/customDetail',
        name: 'customDetail',
        component: customDetail
      },
      {
        path: '/promote',
        name: 'promote',
        component: promote
      },
      {
        path: '/teacherIntentionList',
        name: 'teacherIntentionList',
        component: teacherIntentionList
      },
      {
        path: '/myBill',
        name: 'myBill',
        component: myBill
      },
      {
        path: '/myWater',
        name: 'myWater',
        component: myWater
      },
      {
        path: '/switchLogin',
        name: 'switchLogin',
        component: switchLogin
      }, {
        path: '/independent',
        name: 'independent',
        component: independent
      }, {
        path: '/growthDetail',
        name: 'growthDetail',
        component: growthDetail
      }, {
        path: '/term',
        name: 'term',
        component: term
      },
      {
        path: '/jump',
        name: 'jump',
        component: jump
      },
      {
        path: '/chooseSubjects',
        name: 'chooseSubjects',
        component: chooseSubjects
      },
      {
        path: '/zhiyeDetail',
        name: 'zhiyeDetail',
        component: zhiyeDetail
      },
      {
        path: '/zhiyeList',
        name: 'zhiyeList',
        component: zhiyeList
      }, {
        path: '/addRecord',
        name: 'addRecord',
        component: addRecord
      },
      {
        path: '/aiList',
        name: 'aiList',
        component: aiList
      },
      {
        path: '/growthRecord',
        name: 'growthRecord',
        component: growthRecord
      },
      {
        path: '/artificialList',
        name: 'artificialList',
        component: artificialList
      },
      {
        path: '/mbti',
        name: 'mbti',
        component: mbti
      },
      {
        path: '/huolandeResult',
        name: 'huolandeResult',
        component: huolandeResult
      }, {
        path: '/huolande',
        name: 'huolande',
        component: huolande
      },
      {
        path: '/testResult',
        name: 'testResult',
        component: testResult
      },
      {
        path: '/myvol',
        name: 'myvol',
        component: myvol
      },
      {
        path: '/volSchoolList',
        name: 'volSchoolList',
        component: volSchoolList
      },
      {
        path: '/aiChange',
        name: 'aiChange',
        component: aiChange
      },
      {
        path: '/ai',
        name: 'ai',
        component: ai
      },
      {
        path: '/form',
        name: 'form',
        component: form
      },
      {
        path: '/xinxiDetail',
        name: 'xinxiDetail',
        component: xinxiDetail
      },
      {
        path: '/xinxi',
        name: 'xinxi',
        component: xinxi
      },
      {
        path: '/yifenyiduan',
        name: 'yifenyiduan',
        component: yifenyiduan
      },
      {
        path: '/Guide',
        name: 'Guide',
        component: Guide
      },
      {
        path: '/artificial',
        name: 'artificial',
        component: artificial
      },
      {
        path: '/yuyue',
        name: 'yuyue',
        component: yuyue
      },
      {
        path: '/focusProfessional',
        name: 'focusProfessional',
        component: focusProfessional
      },
      {
        path: '/feedback',
        name: 'feedback',
        component: feedback
      },
      {
        path: '/focusSchool',
        name: 'focusSchool',
        component: focusSchool
      },
      {
        path: '/provinceLine',
        name: 'provinceLine',
        component: provinceLine
      },
      {
        path: '/personalCenter',
        name: 'personalCenter',
        component: personalCenter
      },
      {
        path: '/futureEasy',
        name: 'futureEasy',
        component: futureEasy
      },
      {
        path: '/specialtyDetail',
        name: 'specialtyDetail',
        component: specialtyDetail
      },
      {
        path: '/schoolList',
        name: 'schoolList',
        component: schoolList
      },
      {
        path: '/schoolDetail',
        name: 'schoolDetail',
        component: schoolDetail
      },
      {
        path: '/rank',
        name: 'rank',
        component: rank
      },
      {
        path: '/specialtyList',
        name: 'specialtyList',
        component: specialtyList,
        meta: {
          keepAlive: true
        }
      },
      // {
      //   path: '/scoretable',
      //  name: 'scoretable',
      //  component: scoretable
      // },
      {
        path: '/openSchool',
        name: 'openSchool',
        component: openSchool
      },
    ]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js